// extracted by mini-css-extract-plugin
module.exports = {"root":"numpad_root__2MFS3","button":"numpad_button__2UxDU"};